import {useEffect, useState} from "react";

export const Typewriter = (props: { text: String, type: 'Letter' | 'Word' | 'Sentence' | 'Paragraph' | 'All' }) => {
    const [currentText, setCurrentText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    var separators: any
    var delay: number
    const [parts, setParts] = useState(props.type == 'All' ? [props.text] : props.text.split(separators))
    useEffect(() => {
        if (currentIndex < parts.length) {
            const timeout = setTimeout(() => {
                setCurrentText(prevText => prevText + parts[currentIndex]);
                setCurrentIndex(prevIndex => prevIndex + 1);
            }, delay);

            return () => clearTimeout(timeout);
        }
    }, [currentIndex, props.text]);

    useEffect(() => {
        separators = props.type === 'Letter' ? '' : props.type === 'Word' ? /([\s])+/ : props.type === 'Sentence' ? /([.!?])+/ : /([\n])+/
        delay = props.type === 'Letter' ? 20 : props.type === 'Word' ? 40 : props.type === 'Sentence' ? 100 : 400
        setCurrentIndex(0)
        setCurrentText('')
        setParts(props.type == 'All' ? [props.text] : props.text.split(separators))
    }, [props.text])

    return <span>{currentText}</span>;
}